module.exports = __webpack_public_path__ + "media/npc_dota_hero_lone_druid.57271ae3.webm";